import React from "react";
import { Tabs } from "antd";
import InvetoryTable from "./components/InventoryTable";
import { Pagination } from "../../components/atoms/pagination";

const InventoryTabs = ({
  list,
  pagination,
  setPagination,
  pageInfo,
  loading,
  count,
  storeName,
}) => {
  const tabItems = [
    {
      key: "1",
      label: (
        <span
          onClick={() => {
            setPagination({
              ...pagination,
              paginationFilter: { offset: 0, limit: 10, order: "DESC" },
              status: "ALL",
              onSale: null,
              stockStatus: null,
            });
          }}
        >
          All <span>({count?.all || 0})</span>
        </span>
      ),
      children: (
        <InvetoryTable
          key="1"
          list={list}
          pagination={pagination}
          loading={loading}
          storeName={storeName}
        />
      ),
    },
    {
      key: "2",
      label: (
        <span
          onClick={() => {
            setPagination({
              ...pagination,
              paginationFilter: { offset: 0, limit: 10, order: "DESC" },
              status: "ACTIVE",
              onSale: null,
              stockStatus: null,
            });
          }}
        >
          Published <span>({count?.published || 0})</span>
        </span>
      ),
      children: (
        <InvetoryTable
          tabKey="2"
          list={list}
          pagination={pagination}
          loading={loading}
          storeName={storeName}
        />
      ),
    },
    {
      key: "3",
      label: (
        <span
          onClick={() => {
            setPagination({
              ...pagination,
              paginationFilter: { offset: 0, limit: 10, order: "DESC" },
              stockStatus: "IN_STOCK",
              status: null,
              onSale: null,
            });
          }}
        >
          In-Stock <span>({count?.inStock || 0})</span>
        </span>
      ),
      children: (
        <InvetoryTable
          tabKey="3"
          list={list}
          pagination={pagination}
          loading={loading}
          storeName={storeName}
        />
      ),
    },
    {
      key: "4",
      label: (
        <span
          onClick={() => {
            setPagination({
              ...pagination,
              paginationFilter: { offset: 0, limit: 10, order: "DESC" },
              stockStatus: "OUT_OF_STOCK",
              status: null,
              onSale: null,
            });
          }}
        >
          Out of Stock <span>({count?.outStock || 0})</span>
        </span>
      ),

      children: (
        <InvetoryTable
          tabKey="4"
          list={list}
          pagination={pagination}
          loading={loading}
          storeName={storeName}
        />
      ),
    },
    {
      key: "5",
      label: (
        <span
          onClick={() => {
            setPagination({
              ...pagination,
              paginationFilter: { offset: 0, limit: 10, order: "DESC" },
              status: "INACTIVE",
              stockStatus: null,
              onSale: null,
            });
          }}
        >
          Unpublished <span>({count?.unPublished || 0})</span>
        </span>
      ),
      children: (
        <InvetoryTable
          tabKey="5"
          list={list}
          pagination={pagination}
          loading={loading}
          storeName={storeName}
        />
      ),
    },
    {
      key: "6",
      label: (
        <span
          onClick={() => {
            setPagination({
              ...pagination,
              paginationFilter: { offset: 0, limit: 10, order: "DESC" },
              onSale: "ON_SALE",
              stockStatus: null,
              status: null,
            });
          }}
        >
          On sale <span>({count?.sale || 0})</span>
        </span>
      ),
      children: (
        <InvetoryTable
          tabKey="6"
          list={list}
          pagination={pagination}
          loading={loading}
          storeName={storeName}
        />
      ),
    },
  ];

  return (
    <div>
      <Tabs defaultActiveKey="1" items={tabItems} />

    </div>
  );
};

export default InventoryTabs;
